import {
  CHANGE_LANGUAGE
} from "./types";

// eslint-disable-next-line import/prefer-default-export
export const onChangeLanguage = (language) => dispatch =>
  dispatch({
    type: CHANGE_LANGUAGE,
    language
  })